import {
    ADD_PRODUCT_REQUEST,
    ADD_PRODUCT_SUCCESS,
    ADD_PRODUCT_FAILURE,
    FETCH_PRODUCT_REQUEST,
    FETCH_PRODUCT_SUCCESS,
    FETCH_PRODUCT_FAILURE,
    UPDATE_PRODUCT_REQUEST,
    UPDATE_PRODUCT_SUCCESS,
    UPDATE_PRODUCT_FAILURE,
    DELETE_PRODUCT_REQUEST,
    DELETE_PRODUCT_SUCCESS,
    DELETE_PRODUCT_FAILURE,
} from "../actions/ProductGroupActions";


const initialState = {
    loading: false,
    productGroup: [],
    error: "",
    addSuccess: "",
    fetchSuccess: "",
    updateSuccess: "",
    deleteSuccess: "",
};

const productGroupReducer = (state = initialState, action) => {
    switch (action.type) {
    case ADD_PRODUCT_REQUEST:
        return { ...state, loading: true, addSuccess: "", fetchSuccess: "", updateSuccess: "", deleteSuccess: ""  };
    case ADD_PRODUCT_SUCCESS:
        return {
            ...state,
            loading: false,
            addSuccess: action.payload,
            error: "",
        };
    case ADD_PRODUCT_FAILURE:
        return {
            ...state,
            loading: false,
            addSuccess: "",
            productGroup: [],
            error: action.payload,
        };
    case FETCH_PRODUCT_REQUEST:
        return { ...state, loading: true, addSuccess: "", fetchSuccess: "", updateSuccess: "", deleteSuccess: ""   };
    case FETCH_PRODUCT_SUCCESS:
        return {
            ...state,
            loading: false,
            fetchSuccess: action?.payload?.productGroup,
            productGroup: action?.payload?.productGroup,
            error: "",
        };
    case FETCH_PRODUCT_FAILURE:
        return {
            ...state,
            loading: false,
            fetchSuccess: "",
            productGroup: [],
            error: action.payload,
        };
    case UPDATE_PRODUCT_REQUEST:
        return { ...state, loading: true, addSuccess: "", fetchSuccess: "", updateSuccess: "", deleteSuccess: "" };
    case UPDATE_PRODUCT_SUCCESS:
        return {
            ...state,
            loading: false,
            updateSuccess: action.payload,
            error: "",
        };
    case UPDATE_PRODUCT_FAILURE:
        return {
            ...state,
            loading: false,
            updateSuccess: "",
            productGroup: [],
            error: action.payload,
        };
    case DELETE_PRODUCT_REQUEST:
        return { ...state, loading: true, addSuccess: "", fetchSuccess: "", updateSuccess: "", deleteSuccess: ""  };
    case DELETE_PRODUCT_SUCCESS:
        return {
            ...state,
            loading: false,
            deleteSuccess: action.payload,
            error: "",
        };
    case DELETE_PRODUCT_FAILURE:
        return {
            ...state,
            loading: false,
            deleteSuccess: "",
            productGroup: [],
            error: action.payload,
        };
    default:
        return state;
    }
};

export default productGroupReducer;